import { render, staticRenderFns } from "./MonitoringScreen.vue?vue&type=template&id=3967a441&scoped=true"
import script from "./MonitoringScreen.vue?vue&type=script&lang=js"
export * from "./MonitoringScreen.vue?vue&type=script&lang=js"
import style0 from "./MonitoringScreen.vue?vue&type=style&index=0&id=3967a441&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3967a441",
  null
  
)

export default component.exports